import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleOrganisation extends TitleBase {
	protected canHandle(): boolean {
		return this.filters.some((_) => _.type === ParameterType.ORGANISATIONS && _.values.length === 1);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} offered by the university`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType);
	}
}
